import { RichText, RichTextBlock } from "prismic-reactjs"
import React from 'react'
import { prismicLink } from '../prismic.link'

interface Props {
  primary: {
    title: RichTextBlock[]
    text: RichTextBlock[]
    text_align: 'center' | 'left' | 'right'
  },
  items: any[]
}

export const TextSlice: React.FC<Props> = (props) => {
  return (
    <div style={{ textAlign: props.primary.text_align }}>
      <RichText render={props.primary.title} serializeHyperlink={prismicLink as any} />
      <RichText render={props.primary.text} serializeHyperlink={prismicLink as any}/>
    </div>
  )
}
